import { PRODUCT_LISTING_DEFAULT_COUNT, INIT_FILTERS, priceTypesLabels } from 'constants';
import { stringToArray } from 'utils';
import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  pageSize: PRODUCT_LISTING_DEFAULT_COUNT,
  filters: INIT_FILTERS,
  filterLabels: { ...priceTypesLabels },
};

const productFilters = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.CLEAR_ALL_FILTERS:
      return {
        ...INITIAL_STATE,
        filters: {
          ...INITIAL_STATE.filters,
          sortBy: state.filters.sortBy,
          sortDirection: state.filters.sortDirection,
          text: payload.leaveText ? state.filters.text : INITIAL_STATE.filters.text,
        },
      };

    case actions.SET_FILTER_CATEGORY:
      return {
        ...state,
        filters: {
          ...state.filters,
          [payload.category]: payload.data,
        },
      };

    case actions.CLEAR_FILTER_CATEGORY:
      return {
        ...state,
        filters: {
          ...state.filters,
          [payload.category]: payload.value
            ? stringToArray(state.filters[payload.category])
                .filter((value) => value !== payload.value)
                .join(',')
            : INITIAL_STATE.filters[payload.category],
        },
      };

    case actions.SET_FILTER_LABELS:
      return {
        ...state,
        filterLabels: { ...INITIAL_STATE.filterLabels, ...payload },
      };

    default:
      return state;
  }
};

export default productFilters;
